import { discord as IconDiscord } from '@/components/icons/discord';
import { faucet as IconFaucet } from '@/components/icons/faucet';
import { file as IconFile } from '@/components/icons/file';
import { overview as IconOverview } from '@/components/icons/overview';
import { quanta as IconQuanta } from '@/components/icons/quanta';
import { telegramSideBar as IconTelegramSideBar } from '@/components/icons/telegramSideBar';
import { twitter as IconTwitter } from '@/components/icons/twitter';
import { vault as IconVault } from '@/components/icons/vault';
import { water as IconWater } from '@/components/icons/water';
import { FEATURES } from '@/constants';

import UnitBridgeIcon from './UnitBridgeIcon';

interface SidebarItem {
  /** Key within the `layout` message namespace. */
  labelKey: string;
  href: string;
  icon?: React.ReactNode;
  subItems?: SidebarItem[];
}

interface InfoItem {
  icon: React.ReactNode;
  name: string;
  labelKey?: string;
  href: string;
}

export const sidebarData: SidebarItem[] = [
  {
    icon: <IconOverview />,
    labelKey: 'nav.analytics',
    href: '/overview',
  },
  {
    icon: <IconVault />,
    labelKey: 'nav.vault',
    href: '/',
  },
  ...(FEATURES.liquidityPoolPageOn
    ? [
        {
          icon: <IconWater />,
          labelKey: 'nav.liquidityPool',
          href: '/liquidity-pool',
        },
      ]
    : []),
  ...(FEATURES.unitBridgePageOn
    ? [
        {
          icon: <UnitBridgeIcon />,
          labelKey: 'nav.unitBridge',
          href: '/unit-bridge',
        },
      ]
    : []),
  {
    icon: <IconFaucet />,
    labelKey: 'nav.faucet',
    href: '/faucet',
  },
  {
    icon: <IconQuanta />,
    labelKey: 'nav.quanta',
    href: '/quanta',
    subItems: [
      {
        labelKey: 'nav.missions',
        href: '/quanta/missions',
      },
      {
        labelKey: 'nav.leaderboard',
        href: '/quanta/leaderboard',
      },
    ],
  },
];

export const infoData: InfoItem[] = [
  {
    icon: <IconFile />,
    name: 'File',
    labelKey: 'documentation',
    href: 'https://docs.ducatprotocol.com',
  },
  {
    icon: <IconTwitter />,
    name: 'Twitter',
    href: 'https://x.com/Ducatstable',
  },
  {
    icon: <IconDiscord />,
    name: 'Discord',
    href: 'https://discord.gg/ducat',
  },
  {
    icon: <IconTelegramSideBar />,
    name: 'Telegram',
    href: 'http://t.me/ducat_announcements',
  },
];
